<greco-simple-dialog [data]="dialogData" *ngIf="data.subscription" class="subscription-container">
  <greco-subscription
    [communityId]="data.communityId || undefined"
    [subscription]="data.subscription"
  ></greco-subscription>
</greco-simple-dialog>
